<div class="lmo-frac-home-card">
  <header>
    <div class="title">
      <ng-content select="header"></ng-content>
    </div>
    <button mat-icon-button (click)="toggleVisibility()">
      <mat-icon class="menu-icon" *ngIf="visible$ | async; else notVisibleIcon">expand_less</mat-icon>
      <ng-template #notVisibleIcon>
        <mat-icon class="menu-icon">expand_more</mat-icon>
      </ng-template>
    </button>
  </header>
  <main [@slideInAndOut] *ngIf="visible$ | async">
    <ng-container *ngIf="!isLoading; else loading">
      <ng-content></ng-content>
    </ng-container>
  </main>
</div>

<ng-template #loading>
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
